/**
 * Asynchronously loads the component for Assessments
 */
import Loadable from "react-loadable";

export default Loadable({
  loader: () => import("."),
  loading: () => null
});
